module.exports = __webpack_public_path__ + "img/digital_tree_ori.230b3a54.svg";